/* tslint:disable */
/* eslint-disable */
/**
 * 不系舟 (lfr-unmoored) API
 * Family Hub 后端 API — Go 重写版。  Phase 2 codegen-ready 版本（SPEC-1..SPEC-9 完成）： - 全 path 带 operationId（驼峰命名） - 4xx/5xx 统一响应 ErrorResponse - 时间字段统一 date-time（RFC3339） - schema 标 required - request body 抽出命名 schema（XxxCreateRequest / XxxUpdateRequest） - v2.1.1 (BE-S5-002): content/text 字段加 description，明确语义边界 - v2.6.0 (BE-S11-001): 新增日程模块 /api/schedule/items（单日/区间查询、单条 CRUD、   批量整周替换、DDL 截止前一天提醒），数据按 X-User 隔离 - v2.7.0 (BE-TD-001): 既有漂移治理——补齐 68 个已上线 BE 路由（okr/memo/meetings/   tasks/shares/packing/travel/health/growth/agent/metrics/auth/todo 13 域），   listGrowth 返回类型修正为 map（对齐生产实现），spec ↔ BE 恢复 1:1 - v2.8.0: 日程新增 meal 类型；training / meal 通过 note 传递结构化计划详情 - v2.9.0: 日程新增 category 字段，删除「其他」兜底分区；所有事项必须归类为   timeline|work_plan|training_plan|meal_plan|life - v2.10.0: 新增自省语录 /api/okr/reflection（与 /api/okr/backdrop 同构，独立表） - v2.11.0 (PRD v3 待办+日程合并): /api/work/todo 升级为统一任务查询——新增   date/from/to 日历区间、status（含 overdue/held/pending 特殊口径）、type/tag 过滤，   新增 GET /api/work/todo/{id}；Todo schema 补 type/category/tag/url/startDate/   deadline/time/remindBefore/remindedAt/heldSince/createdAt/updatedAt，status 统一   6 值枚举（in_progress 下划线）；/api/schedule/items 转为过渡期别名（数据源=todos   单表，响应契约不变，标记 deprecated） 
 *
 * The version of the OpenAPI document: 2.13.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ListTodos200Response } from '../models';
// @ts-ignore
import type { SortOrderItem } from '../models';
// @ts-ignore
import type { Todo } from '../models';
// @ts-ignore
import type { TodoCreateRequest } from '../models';
// @ts-ignore
import type { TodoUpdateRequest } from '../models';
/**
 * TodoApi - axios parameter creator
 * @export
 */
export const TodoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create todo
         * @param {TodoCreateRequest} todoCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTodo: async (todoCreateRequest: TodoCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todoCreateRequest' is not null or undefined
            assertParamExists('createTodo', 'todoCreateRequest', todoCreateRequest)
            const localVarPath = `/api/work/todo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(todoCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a todo
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTodo: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTodo', 'id', id)
            const localVarPath = `/api/work/todo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a todo
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodo: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTodo', 'id', id)
            const localVarPath = `/api/work/todo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 三种模式（PRD v3）： - 日历模式：date 或 from/to（区间上限 62 天），返回 [startDate, deadline] 与区间有交集的排期行，响应 {items: Todo[]} - 状态模式：status（无日期），支持 overdue/held/pending 特殊口径（对齐原日程语义），响应 {items: Todo[]} - 列表模式：无 date/from/to/status，返回全部可见行（cursor 分页） 可见性规则：user==X OR owner[]含X OR followers[]含X OR scope==\'team\' 
         * @summary List todos（统一任务查询）
         * @param {string} [date] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {ListTodosStatusEnum} [status] 
         * @param {ListTodosTypeEnum} [type] 
         * @param {string} [tag] 
         * @param {ListTodosScopeEnum} [scope] 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTodos: async (date?: string, from?: string, to?: string, status?: ListTodosStatusEnum, type?: ListTodosTypeEnum, tag?: string, scope?: ListTodosScopeEnum, cursor?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/work/todo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Batch replace all todos for current user
         * @param {Array<Todo>} todo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceTodos: async (todo: Array<Todo>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todo' is not null or undefined
            assertParamExists('replaceTodos', 'todo', todo)
            const localVarPath = `/api/work/todo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(todo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Batch update todo sort order
         * @param {Array<SortOrderItem>} sortOrderItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortTodos: async (sortOrderItem: Array<SortOrderItem>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortOrderItem' is not null or undefined
            assertParamExists('sortTodos', 'sortOrderItem', sortOrderItem)
            const localVarPath = `/api/work/todo/sort`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sortOrderItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a todo
         * @param {string} id 
         * @param {TodoUpdateRequest} todoUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTodo: async (id: string, todoUpdateRequest: TodoUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTodo', 'id', id)
            // verify required parameter 'todoUpdateRequest' is not null or undefined
            assertParamExists('updateTodo', 'todoUpdateRequest', todoUpdateRequest)
            const localVarPath = `/api/work/todo/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(todoUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TodoApi - functional programming interface
 * @export
 */
export const TodoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TodoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create todo
         * @param {TodoCreateRequest} todoCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTodo(todoCreateRequest: TodoCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Todo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTodo(todoCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TodoApi.createTodo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a todo
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTodo(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTodo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TodoApi.deleteTodo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a todo
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTodo(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Todo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TodoApi.getTodo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 三种模式（PRD v3）： - 日历模式：date 或 from/to（区间上限 62 天），返回 [startDate, deadline] 与区间有交集的排期行，响应 {items: Todo[]} - 状态模式：status（无日期），支持 overdue/held/pending 特殊口径（对齐原日程语义），响应 {items: Todo[]} - 列表模式：无 date/from/to/status，返回全部可见行（cursor 分页） 可见性规则：user==X OR owner[]含X OR followers[]含X OR scope==\'team\' 
         * @summary List todos（统一任务查询）
         * @param {string} [date] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {ListTodosStatusEnum} [status] 
         * @param {ListTodosTypeEnum} [type] 
         * @param {string} [tag] 
         * @param {ListTodosScopeEnum} [scope] 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTodos(date?: string, from?: string, to?: string, status?: ListTodosStatusEnum, type?: ListTodosTypeEnum, tag?: string, scope?: ListTodosScopeEnum, cursor?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTodos200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTodos(date, from, to, status, type, tag, scope, cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TodoApi.listTodos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Batch replace all todos for current user
         * @param {Array<Todo>} todo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceTodos(todo: Array<Todo>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Todo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceTodos(todo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TodoApi.replaceTodos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Batch update todo sort order
         * @param {Array<SortOrderItem>} sortOrderItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sortTodos(sortOrderItem: Array<SortOrderItem>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sortTodos(sortOrderItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TodoApi.sortTodos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a todo
         * @param {string} id 
         * @param {TodoUpdateRequest} todoUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTodo(id: string, todoUpdateRequest: TodoUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Todo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTodo(id, todoUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TodoApi.updateTodo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TodoApi - factory interface
 * @export
 */
export const TodoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TodoApiFp(configuration)
    return {
        /**
         * 
         * @summary Create todo
         * @param {TodoApiCreateTodoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTodo(requestParameters: TodoApiCreateTodoRequest, options?: RawAxiosRequestConfig): AxiosPromise<Todo> {
            return localVarFp.createTodo(requestParameters.todoCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a todo
         * @param {TodoApiDeleteTodoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTodo(requestParameters: TodoApiDeleteTodoRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTodo(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a todo
         * @param {TodoApiGetTodoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodo(requestParameters: TodoApiGetTodoRequest, options?: RawAxiosRequestConfig): AxiosPromise<Todo> {
            return localVarFp.getTodo(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 三种模式（PRD v3）： - 日历模式：date 或 from/to（区间上限 62 天），返回 [startDate, deadline] 与区间有交集的排期行，响应 {items: Todo[]} - 状态模式：status（无日期），支持 overdue/held/pending 特殊口径（对齐原日程语义），响应 {items: Todo[]} - 列表模式：无 date/from/to/status，返回全部可见行（cursor 分页） 可见性规则：user==X OR owner[]含X OR followers[]含X OR scope==\'team\' 
         * @summary List todos（统一任务查询）
         * @param {TodoApiListTodosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTodos(requestParameters: TodoApiListTodosRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListTodos200Response> {
            return localVarFp.listTodos(requestParameters.date, requestParameters.from, requestParameters.to, requestParameters.status, requestParameters.type, requestParameters.tag, requestParameters.scope, requestParameters.cursor, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Batch replace all todos for current user
         * @param {TodoApiReplaceTodosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceTodos(requestParameters: TodoApiReplaceTodosRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Todo>> {
            return localVarFp.replaceTodos(requestParameters.todo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Batch update todo sort order
         * @param {TodoApiSortTodosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sortTodos(requestParameters: TodoApiSortTodosRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sortTodos(requestParameters.sortOrderItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a todo
         * @param {TodoApiUpdateTodoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTodo(requestParameters: TodoApiUpdateTodoRequest, options?: RawAxiosRequestConfig): AxiosPromise<Todo> {
            return localVarFp.updateTodo(requestParameters.id, requestParameters.todoUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TodoApi - interface
 * @export
 * @interface TodoApi
 */
export interface TodoApiInterface {
    /**
     * 
     * @summary Create todo
     * @param {TodoApiCreateTodoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApiInterface
     */
    createTodo(requestParameters: TodoApiCreateTodoRequest, options?: RawAxiosRequestConfig): AxiosPromise<Todo>;

    /**
     * 
     * @summary Delete a todo
     * @param {TodoApiDeleteTodoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApiInterface
     */
    deleteTodo(requestParameters: TodoApiDeleteTodoRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get a todo
     * @param {TodoApiGetTodoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApiInterface
     */
    getTodo(requestParameters: TodoApiGetTodoRequest, options?: RawAxiosRequestConfig): AxiosPromise<Todo>;

    /**
     * 三种模式（PRD v3）： - 日历模式：date 或 from/to（区间上限 62 天），返回 [startDate, deadline] 与区间有交集的排期行，响应 {items: Todo[]} - 状态模式：status（无日期），支持 overdue/held/pending 特殊口径（对齐原日程语义），响应 {items: Todo[]} - 列表模式：无 date/from/to/status，返回全部可见行（cursor 分页） 可见性规则：user==X OR owner[]含X OR followers[]含X OR scope==\'team\' 
     * @summary List todos（统一任务查询）
     * @param {TodoApiListTodosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApiInterface
     */
    listTodos(requestParameters?: TodoApiListTodosRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTodos200Response>;

    /**
     * 
     * @summary Batch replace all todos for current user
     * @param {TodoApiReplaceTodosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApiInterface
     */
    replaceTodos(requestParameters: TodoApiReplaceTodosRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Todo>>;

    /**
     * 
     * @summary Batch update todo sort order
     * @param {TodoApiSortTodosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApiInterface
     */
    sortTodos(requestParameters: TodoApiSortTodosRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update a todo
     * @param {TodoApiUpdateTodoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApiInterface
     */
    updateTodo(requestParameters: TodoApiUpdateTodoRequest, options?: RawAxiosRequestConfig): AxiosPromise<Todo>;

}

/**
 * Request parameters for createTodo operation in TodoApi.
 * @export
 * @interface TodoApiCreateTodoRequest
 */
export interface TodoApiCreateTodoRequest {
    /**
     * 
     * @type {TodoCreateRequest}
     * @memberof TodoApiCreateTodo
     */
    readonly todoCreateRequest: TodoCreateRequest
}

/**
 * Request parameters for deleteTodo operation in TodoApi.
 * @export
 * @interface TodoApiDeleteTodoRequest
 */
export interface TodoApiDeleteTodoRequest {
    /**
     * 
     * @type {string}
     * @memberof TodoApiDeleteTodo
     */
    readonly id: string
}

/**
 * Request parameters for getTodo operation in TodoApi.
 * @export
 * @interface TodoApiGetTodoRequest
 */
export interface TodoApiGetTodoRequest {
    /**
     * 
     * @type {string}
     * @memberof TodoApiGetTodo
     */
    readonly id: string
}

/**
 * Request parameters for listTodos operation in TodoApi.
 * @export
 * @interface TodoApiListTodosRequest
 */
export interface TodoApiListTodosRequest {
    /**
     * 
     * @type {string}
     * @memberof TodoApiListTodos
     */
    readonly date?: string

    /**
     * 
     * @type {string}
     * @memberof TodoApiListTodos
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof TodoApiListTodos
     */
    readonly to?: string

    /**
     * 
     * @type {'pending' | 'in_progress' | 'blocked' | 'held' | 'completed' | 'cancelled' | 'overdue'}
     * @memberof TodoApiListTodos
     */
    readonly status?: ListTodosStatusEnum

    /**
     * 
     * @type {'work' | 'learning' | 'training' | 'meal' | 'fixed' | 'ddl'}
     * @memberof TodoApiListTodos
     */
    readonly type?: ListTodosTypeEnum

    /**
     * 
     * @type {string}
     * @memberof TodoApiListTodos
     */
    readonly tag?: string

    /**
     * 
     * @type {'team' | 'personal'}
     * @memberof TodoApiListTodos
     */
    readonly scope?: ListTodosScopeEnum

    /**
     * 
     * @type {string}
     * @memberof TodoApiListTodos
     */
    readonly cursor?: string

    /**
     * 
     * @type {number}
     * @memberof TodoApiListTodos
     */
    readonly limit?: number
}

/**
 * Request parameters for replaceTodos operation in TodoApi.
 * @export
 * @interface TodoApiReplaceTodosRequest
 */
export interface TodoApiReplaceTodosRequest {
    /**
     * 
     * @type {Array<Todo>}
     * @memberof TodoApiReplaceTodos
     */
    readonly todo: Array<Todo>
}

/**
 * Request parameters for sortTodos operation in TodoApi.
 * @export
 * @interface TodoApiSortTodosRequest
 */
export interface TodoApiSortTodosRequest {
    /**
     * 
     * @type {Array<SortOrderItem>}
     * @memberof TodoApiSortTodos
     */
    readonly sortOrderItem: Array<SortOrderItem>
}

/**
 * Request parameters for updateTodo operation in TodoApi.
 * @export
 * @interface TodoApiUpdateTodoRequest
 */
export interface TodoApiUpdateTodoRequest {
    /**
     * 
     * @type {string}
     * @memberof TodoApiUpdateTodo
     */
    readonly id: string

    /**
     * 
     * @type {TodoUpdateRequest}
     * @memberof TodoApiUpdateTodo
     */
    readonly todoUpdateRequest: TodoUpdateRequest
}

/**
 * TodoApi - object-oriented interface
 * @export
 * @class TodoApi
 * @extends {BaseAPI}
 */
export class TodoApi extends BaseAPI implements TodoApiInterface {
    /**
     * 
     * @summary Create todo
     * @param {TodoApiCreateTodoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApi
     */
    public createTodo(requestParameters: TodoApiCreateTodoRequest, options?: RawAxiosRequestConfig) {
        return TodoApiFp(this.configuration).createTodo(requestParameters.todoCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a todo
     * @param {TodoApiDeleteTodoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApi
     */
    public deleteTodo(requestParameters: TodoApiDeleteTodoRequest, options?: RawAxiosRequestConfig) {
        return TodoApiFp(this.configuration).deleteTodo(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a todo
     * @param {TodoApiGetTodoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApi
     */
    public getTodo(requestParameters: TodoApiGetTodoRequest, options?: RawAxiosRequestConfig) {
        return TodoApiFp(this.configuration).getTodo(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 三种模式（PRD v3）： - 日历模式：date 或 from/to（区间上限 62 天），返回 [startDate, deadline] 与区间有交集的排期行，响应 {items: Todo[]} - 状态模式：status（无日期），支持 overdue/held/pending 特殊口径（对齐原日程语义），响应 {items: Todo[]} - 列表模式：无 date/from/to/status，返回全部可见行（cursor 分页） 可见性规则：user==X OR owner[]含X OR followers[]含X OR scope==\'team\' 
     * @summary List todos（统一任务查询）
     * @param {TodoApiListTodosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApi
     */
    public listTodos(requestParameters: TodoApiListTodosRequest = {}, options?: RawAxiosRequestConfig) {
        return TodoApiFp(this.configuration).listTodos(requestParameters.date, requestParameters.from, requestParameters.to, requestParameters.status, requestParameters.type, requestParameters.tag, requestParameters.scope, requestParameters.cursor, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Batch replace all todos for current user
     * @param {TodoApiReplaceTodosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApi
     */
    public replaceTodos(requestParameters: TodoApiReplaceTodosRequest, options?: RawAxiosRequestConfig) {
        return TodoApiFp(this.configuration).replaceTodos(requestParameters.todo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Batch update todo sort order
     * @param {TodoApiSortTodosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApi
     */
    public sortTodos(requestParameters: TodoApiSortTodosRequest, options?: RawAxiosRequestConfig) {
        return TodoApiFp(this.configuration).sortTodos(requestParameters.sortOrderItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a todo
     * @param {TodoApiUpdateTodoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodoApi
     */
    public updateTodo(requestParameters: TodoApiUpdateTodoRequest, options?: RawAxiosRequestConfig) {
        return TodoApiFp(this.configuration).updateTodo(requestParameters.id, requestParameters.todoUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum ListTodosStatusEnum {
    PENDING = 'pending',
    IN_PROGRESS = 'in_progress',
    BLOCKED = 'blocked',
    HELD = 'held',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
    OVERDUE = 'overdue'
}
/**
  * @export
  * @enum {string}
  */
export enum ListTodosTypeEnum {
    WORK = 'work',
    LEARNING = 'learning',
    TRAINING = 'training',
    MEAL = 'meal',
    FIXED = 'fixed',
    DDL = 'ddl'
}
/**
  * @export
  * @enum {string}
  */
export enum ListTodosScopeEnum {
    TEAM = 'team',
    PERSONAL = 'personal'
}
